import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { CreateSmartTableRequest, SmartTableDetail, unwrapSmartTableEntityPayload } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useCreateSmartTable = () => {
  const userToken = useAuth()?.userToken ?? "";
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const wid = Number(workspaceId);
  const queryClient = useQueryClient();

  return useMutation<SmartTableDetail, unknown, CreateSmartTableRequest>({
    mutationFn: async payload => {
      const response = await fetch(ENDPOINTS.smart_tables(wid), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(payload),
      });
      const responsePayload = await handleResponse(response);
      return unwrapSmartTableEntityPayload<SmartTableDetail>(responsePayload, "smart_table");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["smart-tables", wid, "list"] });

      if (workspaceId) {
        queryClient.invalidateQueries({ queryKey: ["folder-entities", workspaceId] });
      }
    },
  });
};
